import React, { useState, useContext } from "react"
import { Alert, Box, FormControl, FormHelperText, FormLabel } from "@mui/joy";
import { Controller } from "react-hook-form";
import { useDrawer } from "../Drawer";
import { Button } from '../Button';
import Relationship from "../RelationshipElements/Relationship";
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

import { useTranslation } from 'react-i18next'
import { useDataProvider } from "src/mtska-frontend-data-provider";

const RelationshipManager = ({ dataProviderName, detailStack = {}, modelName, parentitem, relation, editing, required, name, value, label, view, disabled, readonly, className = "", multiple, setValue, checkable, checked, onCheckChange }) => {

    const [error, setError] = useState();

    const { activate } = useDrawer();
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);
    const [loadingDissociation, setLoadingDissociation] = useState(false);

    const {
        doAction
    } = useDataProvider(dataProviderName, false);

    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    const onChange = () => {

    }

    const handleItemRemove = (childitem) => {
        if (typeof childitem === 'undefined') return;
        //console.info("relationship handleItemRemove", childitem);

        if (relation.relationDissociator) {
            activate(relation.relationDissociator, {
                defaultValue: childitem,
                defaultSelectedValues: childitem._id,
                enableSelection: true,
                disableMultipleRowSelection: !multiple,
                parent: { ...parentitem },
                filters: { ...relation.filter }
            }, () => { })
        } else {
            setLoadingDissociation(true);
            doAction && doAction({
                action: 'relationshipDissociation',
                model: dataProviderName,
                data: {
                    relationName: name,
                    parentId: parentitem._id,
                    childrenId: [childitem._id],
                }
            }).then(() => {
                setLoadingDissociation(false);
                console.info('relationshipDissociation completed')
            });
        }
    }

    const handleItemDetailOpen = (v) => {
        //console.info("relationship handleItemDetailOpen", v);
        activate(relation.drawerRoute + '/detail', {
            id: v._id,
            defaultValue: v,
            defaultSelectedValues: [],
            enableSelection: true,
            filters: v,
            detailStack: {
                inverseRelation: { [relation.inverseRelation]: parentitem },
                inverseRelationType: relation.inverseRelationType,
                stack: [...(detailStack.stack ?? []), { [relation.inverseRelation]: parentitem }]
            }
        }, onChange);
    }

    if (!relation.hasOwnProperty('limit')) relation.limit = 1000;

    return (
        <div className={("form-element relationship " + className).trim()}>
            {/* {multiple ? "multiple" : "single"} */}
            <Box className={(error) ? generalClass + " form-element-error" : generalClass}>
                <Box className="form-element-relationship-value">
                    <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                </Box>
                { /* <JSONPretty data={value} className="json-wrapper"></JSONPretty> */}
                <Box className="form-element-relationship-options">
                    { 
                    /*
                        relation.inverseRelation ? <Alert severity="success" sx={{fontSize:'10px',backgroundColor:'#DAFFAE',padding:'3px',marginBottom:'3px'}}>Inverse Relation Defined</Alert> : <Alert severity="error" sx={{fontSize:'10px',backgroundColor:'#FFD8FD',padding:'3px',marginBottom:'3px'}}>Inverse Relation Missing</Alert>
                    */
                    }
                    
                    <Relationship
                        view={view}
                        value={value}
                        filters={parentitem}
                        relation={relation}
                        callback={onChange}
                        editing={editing}
                        visiblelimit={relation.visiblelimit}
                        detailInspector={relation.detailInspector != 'hidden' || userCapabilities['auth/role.is_driver'] ? true : false}
                        handleItemDetail={handleItemDetailOpen}
                        handleItemRemove={relation.relationDissociator != 'hidden' && !userCapabilities['auth/role.is_driver'] ? handleItemRemove : null}
                        setValue={setValue}
                        checkable={checkable}
                        checked={checked}
                        onCheckChange={onCheckChange}
                        loadingDissociation={loadingDissociation}
                    />
                    {((!Array.isArray(value) || relation.limit > value.length) && relation.relationAssociator != 'hidden' && !readonly) && (
                        <Box className="relationship-actions">
                            <Button
                                size="medium"
                                onClick={() => {
                                    if (relation.relationAssociator == 'hidden') return;
                                    return activate(relation.relationAssociator ?? relation.drawerRoute + '/list', {
                                        defaultValue: value,
                                        defaultSelectedValues: value,
                                        enableSelection: true,
                                        disableMultipleRowSelection: !multiple,
                                        filters: { ...relation.filter },
                                        intent: "relationshipManagement",
                                        relation: {
                                            name: name,
                                            dataProviderName: dataProviderName,
                                            parentItemID: parentitem._id,
                                            doAction: doAction
                                        },
                                        detailStack: {
                                            inverseRelation: { [relation.inverseRelation]: parentitem },
                                            inverseRelationType: relation.inverseRelationType,
                                            stack: [...(detailStack.stack ?? []), { [relation.inverseRelation]: parentitem }]
                                        }
                                    }, onChange)
                                }}
                                //label={multiple ? t("select many {{drawerRoute}}", { drawerRoute: relation.drawerRoute }) : t("select a {{drawerRoute}}", { drawerRoute: relation.drawerRoute })}
                                label={multiple ? t("select") : t("select")}
                                icon={multiple ? "faListCheck" : "faListRadio"}
                                variant="outlined"
                                className="relationship-activator"
                                disabled={readonly}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
        </div>
    )
}

export default RelationshipManager
